/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/UI/Navigation',[
    'jquery',
    'global/Logger',
    'plugins/clickMenu'
], function ($, Logger, clickMenu) {
    function init() {
		
		var $cloneNav = $(".navbarWrapper .main-nav").clone();

		
		$cloneNav.appendTo("body").clickMenu({landings:true}).addClass("mobile-nav");
		$(".navbarWrapper .main-nav").clickMenu({landings:true});
		
		$(".siteHeader .header-nav").clone().appendTo(".main-nav.mobile-nav .cm-menu").wrap('<li></li>');						
		
		$(".nav-toggle").on("click", function(e){
			e.preventDefault();

			if ( $(".cm-js-menu-active").length <= 0 && $(".cm-animate-out").length <= 0 ) {
				$('body').children(".main-nav").find(".toggle-menu").trigger("click");
				var winHeight = $('.site-container').height();
				$('body>.main-nav').height(winHeight);
				$('.mobile-nav .account').removeAttr('data-hijax');
				$('.mobile-nav .cartLink').removeAttr('data-hijax');
			}
		});
		
		var $clonedSubs = $cloneNav.find(".cm-menu ul, .cm-menu .custom-sub");
		
		$clonedSubs.each(function(){
			var $sub = $(this),
				$back = $("<a href='#' role='button' class='back'>&lt; Back</a>");

			var $wrap = $sub.is(".custom-sub") ? $("<div class='back-wrap'></div>") : $("<li class='back-wrap'></li>");

			if ( $sub.parents(".custom-sub").length <= 0 ) {
				$wrap.append($back);
				$sub.prepend($wrap);
				$back.on("click", function(e){
					e.preventDefault();
					$sub.siblings(".has-sub").trigger("click");
				});
			}
		});

        var $cloneSideNav = $(".railNavWrapper").clone();

		$cloneSideNav.appendTo("body").clickMenu({ landings: true }).addClass("mobile-navSide");
		$(".railNavWrapper").clickMenu({ landings: true });

        $(".siteHeader .header-nav").clone().appendTo(".railNavWrapper.mobile-navSide .cm-menu").wrap('<li></li>');

        var $impersonationHeight, $portalHeaderHeight, $portalNavHeight, $portalBannerHeight, $portalSearchHeight, $portalHeroHeight;
        var $offsetNav, $offsetBanner, $offsetHero, $offsetContainer, $offsetFooter;
        var $bodyHeight;
        var $portalSearchClosed = false;

        $(".nav-toggle").on("click", function (e) {
            e.preventDefault();

            getPortalHeights();

		    if ($(".cm-js-menu-active").length <= 0 && $(".cm-animate-out").length <= 0) {
		        $('body').children(".railNavWrapper").find(".toggle-menu").trigger("click");
		        var winSideHeight = $('.cm-menu').height();
                $('body>.railNavWrapper').height(winSideHeight);
                $portalNavHeight = $('.mobile-navSide .portal-railNav').height();
            }
            else {
                $portalNavHeight = 0;
            }

            $portalSearchClosed = false;
            setPortalOffsets($portalSearchClosed);

        });


        $(".portal-toggle-search").on("click", function (e) {
            e.preventDefault();

            getPortalHeights();

            var portalSearchHeight = $('.portal-siteContent.search-open').height();

            $portalSearchClosed = false;

            if (portalSearchHeight !== null) {
                $portalSearchClosed = true;
            }

            setPortalOffsets($portalSearchClosed);

        });

        function getPortalHeights() {
            $impersonationHeight = $('.roc-navbar-impersonation').height();
            $portalHeaderHeight = $('.portal-siteHeader').height();
            $portalNavHeight = $('.mobile-navSide .portal-railNav').height();
            $portalBannerHeight = $('.portal-banner').height();
            $portalSearchHeight = $('.portal-banner-search .siteSearch').height();
            $portalHeroHeight = $('.portal-hero').height();

            if ($impersonationHeight !== null) {
                $portalHeaderHeight = $portalHeaderHeight + $impersonationHeight;
            }
        }

        function setPortalOffsets() {
            $bodyHeight = $('body').height();
            $offsetNav = $portalHeaderHeight;
            $offsetBanner = $offsetNav + $portalNavHeight;

            if ($portalSearchClosed) {
                $offsetHero = 186;
            }
            else {
                $offsetHero = $offsetBanner + $portalBannerHeight;
            }
            
            $offsetContainer = $offsetHero + $portalHeroHeight;

            $('.mobile-navSide .portal-railNav').offset({ top: $offsetNav })
            $('.portal-banner').offset({ top: $offsetBanner })
            $('.portal-hero').offset({ top: $offsetHero })
            $('.portal-container').offset({ top: $offsetContainer })

            if ($portalNavHeight !== null) {
                $offsetFooter = $bodyHeight - 59;
                $offsetFooter = $offsetFooter + $portalNavHeight;
                $('.portal-footer').offset({ top: $offsetFooter })
            }

            
        }


		var $clonedSideSubs = $cloneSideNav.find(".cm-menu ul, .cm-menu .custom-sub");

		$clonedSideSubs.each(function () {
		    var $subSide = $(this),
				$backSide = $("<a href='#' role='button' class='back'>&lt; Back</a>");

		    var $wrapSide = $subSide.is(".custom-sub") ? $("<div class='back-wrap'></div>") : $("<li class='back-wrap'></li>");

		    if ($subSide.parents(".custom-sub").length <= 0) {
		        $wrapSide.append($backSide);
		        $subSide.prepend($wrapSide);
		        $backSide.on("click", function (e) {
		            e.preventDefault();
		            $subSide.siblings(".has-sub").trigger("click");
		        });
		    }
		});



    };


    // Initialize mainNavigation
    init();

    var Navigation = { init: init };

    Logger.debug('Navigation.js Loaded:', Navigation);

    return Navigation;
});


